import axios from 'axios';
import { downloadExcel, downloadFile } from '../utils/files';
import {
  ILitigation,
  ILitigationDocument
} from '../utils/interfaces/interfaces';
import { variables } from '../utils/variables';
import { litigii_api } from './routes';

const getCalendar = async () => await axios.get(litigii_api.CALENDAR);

const getLitigii = async (
  page: number,
  filterValue: string,
  sort: string,
  direction: string
) =>
  await axios.get(litigii_api.GET, {
    params: {
      PageNumber: page,
      PageSize: variables.litigationsPaginationRatio,
      search: filterValue,
      sort,
      direction
    }
  });

const getAvailableUsers = async (id: number) =>
  await axios.get(litigii_api.LITIGATION_USERS(id));

const getLitigationUsers = async (id: number) =>
  await axios.get(litigii_api.LITIGATION_USERS(id));

const addLitigationUser = async (litigationId: number, userId: number) => {
  return await axios.post(litigii_api.LITIGATION_USER(litigationId, userId));
};
const removeLitigationUser = async (litigationId: number, userId: number) => {
  return await axios.delete(litigii_api.LITIGATION_USER(litigationId, userId));
};

const getLitigiiByMeasure = async (id: number) =>
  await axios.get(litigii_api.GET_BY_ID(id));

const deleteLitigiiByMeasure = async (id: number) =>
  await axios.delete(litigii_api.DELETE_BY_ID(id));

const addLitigiuByMeasure = async (measureId: number, litigiuId: number) => {
  return await axios.post(litigii_api.ADD_BY_ID, { measureId, litigiuId });
};

const addLitigiu = async (uniqueFileNumber: string) => {
  return await axios.post(litigii_api.ADD, { uniqueFileNumber });
};

const deleteLitigiu = async (id: number) =>
  await axios.delete(litigii_api.DELETE(id));

const getLitigiiDetails = async (id: string) => {
  return await axios.get(litigii_api.GET_DETAILS(id));
};

const editLitigation = async (id: number, litigation: Partial<ILitigation>) =>
  await axios.patch(litigii_api.UPDATE_LITIGATION(id), litigation);

const addLitigationArchiveDocument = async (form: ILitigationDocument) => {
  const data = new FormData();

  data.append('id', form.id.toString());
  data.append('litigationId', form.litigationId.toString());
  data.append('name', form.name);
  data.append('File', form.document!);

  return await axios.post(litigii_api.ADD_ARCHIVE_DOCUMENT, data);
};

const addLitigationDocument = async (form: ILitigationDocument) => {
  const data = new FormData();

  data.append('id', form.id.toString());
  data.append('litigationId', form.litigationId.toString());
  data.append('name', form.name);
  data.append('File', form.document!);
  data.append(
    'documentCommunicationDate',
    form.documentCommunicationDate!.toISOString()
  );
  data.append('term', form.term!.toString());
  data.append('termPeriod', form.termPeriod!.toString());
  data.append('deadline', form.deadline!.toISOString());
  data.append('deadlineConfirmation', form.deadlineConfirmation!.toISOString());

  return await axios.post(litigii_api.ADD_DOCUMENT, data);
};
const importLitigations = async (document: File) => {
  const data = new FormData();

  data.append('File', document);

  return await axios.post(litigii_api.IMPORT, data);
};

const updateLitigationDocument = async (form: ILitigationDocument) => {
  return await axios.patch(litigii_api.UPDATE_DOCUMENT(form.id), form);
};

const downloadLitigationDocument = async (id: number, name: string) => {
  await axios
    .get(litigii_api.DOWNLOAD_DOCUMENT(id), {
      responseType: 'blob'
    })
    .then(({ data }) => {
      downloadFile(data, `${name}`);
    });
};

const downloadLitigationArchiveDocument = async (id: number, name: string) => {
  await axios
    .get(litigii_api.DOWNLOAD_ARCHIVE_DOCUMENT(id), {
      responseType: 'blob'
    })
    .then(({ data }) => {
      downloadFile(data, `${name}`);
    });
};

const downloadRaport = async () => {
  await axios
    .get(litigii_api.DOWNLOAD, {
      responseType: 'blob'
    })
    .then(({ data }) => {
      downloadExcel(data, `litigii`);
    });
};

export {
  getLitigii,
  addLitigiu,
  deleteLitigiu,
  getLitigiiByMeasure,
  deleteLitigiiByMeasure,
  addLitigiuByMeasure,
  getLitigiiDetails,
  editLitigation,
  addLitigationDocument,
  updateLitigationDocument,
  downloadLitigationDocument,
  downloadRaport,
  importLitigations,
  addLitigationArchiveDocument,
  downloadLitigationArchiveDocument,
  getCalendar,
  getAvailableUsers,
  getLitigationUsers,
  addLitigationUser,
  removeLitigationUser
};
